import React from 'react';
import Modal from '../ui/Modal';
import { ContactForm } from './ContactForm';
import { ClientContact, VendorContact, CreateClientContactForm, UpdateClientContactForm, CreateVendorContactForm, UpdateVendorContactForm } from '../../types';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  contact?: ClientContact | VendorContact;
  contactType: 'client' | 'vendor';
  parentId: number;
  onSubmit: (data: CreateClientContactForm | UpdateClientContactForm | CreateVendorContactForm | UpdateVendorContactForm) => void;
  isLoading: boolean;
}

export const ContactModal: React.FC<ContactModalProps> = ({
  isOpen,
  onClose,
  contact,
  contactType,
  parentId,
  onSubmit,
  isLoading
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={contact ? `Edit ${contactType === 'client' ? 'Client' : 'Vendor'} Contact` : `Add New ${contactType === 'client' ? 'Client' : 'Vendor'} Contact`}
      maxWidth="3xl"
    >
      <ContactForm
        contact={contact}
        contactType={contactType}
        parentId={parentId}
        onSubmit={onSubmit}
        onCancel={onClose}
        isLoading={isLoading}
      />
    </Modal>
  );
};
